import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ScrollToHash from './components/ScrollToHash';
import Analytics from './components/Analytics';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductMedicare from './pages/ProductMedicare';
import ProductTienda360 from './pages/ProductTienda360';
import PrivacyMedicare from './pages/PrivacyMedicare';
import presupuestosRoutes from './features/presupuestos/routes';
import './App.css';

// Layout del sitio institucional: Header + Footer alrededor de cada página.
// El módulo de presupuestos NO usa este layout (tiene su propio Topbar).
const MarketingLayout = () => (
  <div className='App'>
    <Header />
    <Outlet />
    <Footer />
  </div>
);

const App = () => {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToHash />
        <Analytics />
        <Routes>
          <Route element={<MarketingLayout />}>
            <Route path='/' element={<Home />} />
            <Route path='/productos' element={<Products />} />
            <Route path='/productos/medicare' element={<ProductMedicare />} />
            <Route
              path='/productos/tienda360'
              element={<ProductTienda360 />}
            />
            <Route
              path='/productos/medicare/privacidad'
              element={<PrivacyMedicare />}
            />
          </Route>
          {presupuestosRoutes}
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
};

export default App;
